import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { TypeDocumentModalDetailComponent } from './modal/typeDocument-modal-detail/typeDocument-modal-detail.component';
import { TypeDocumentModalAjoutComponent } from './modal/typeDocument-modal-ajout/typeDocument-modal-ajout.component';
import { ListTypeDocumentComponent } from './list-typeDocument/list-typeDocument.component';
import { FilterTypeDocumentByNamePipe } from 'src/app/shared/pipes/filter-typeDocument-by-name/filter-typeDocument-by-name.pipe';

@NgModule({
	declarations: [
		ListTypeDocumentComponent,
		TypeDocumentModalDetailComponent,
		TypeDocumentModalAjoutComponent
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterTypeDocumentByNamePipe]
})

export class TypeDocumentModule {}
